// Shared incident-visibility helpers so every map/panel obeys the same
// "auto-hide 12h after last activity" rule.

export const INCIDENT_VISIBLE_MS = 12 * 60 * 60 * 1000;

/**
 * Timestamp (in ms) of the incident's most recent activity — the latest of
 * `last_paged_at`, `updated_at`, `created_at`, and any update log entry.
 */
export function lastActivityMs(inc) {
  if (!inc) return 0;
  const candidates = [inc.last_paged_at, inc.updated_at, inc.created_at];
  const updates = Array.isArray(inc.updates) ? inc.updates : [];
  for (const u of updates) if (u?.timestamp) candidates.push(u.timestamp);
  let max = 0;
  for (const c of candidates) {
    if (!c) continue;
    const t = new Date(c).getTime();
    if (Number.isFinite(t) && t > max) max = t;
  }
  return max;
}

/** True if the incident had ANY activity within the last 12 hours. */
export function isIncidentVisible(inc, now = Date.now()) {
  return now - lastActivityMs(inc) <= INCIDENT_VISIBLE_MS;
}
